<template>
  <section class="CarouselElement ContentSection ContentSection--hasclippath">
    <div>
      <button class="CarouselElement__button CarouselElement__button--prev"
        :class="{ 'CarouselElement__button--inactive': onFirstSlide }" @click="slidePrev"></button>

      <transition-group :name="animations[direction].name">
        <article v-for="(slide, index) in carousel" :key="slide.id" v-show="index == activeSlide">
          <div class="CarouselElement__imgwrapper">
            <LinkWrapper :link="slide.link[0]" v-if="slide.link[0] && slide.image">
              <img :src="getMediaPath(slide.image.src)" :alt="slide.name" />
            </LinkWrapper>
            <img v-else-if="slide.image" :src="getMediaPath(slide.image.src)" :alt="slide.name" />
          </div>
          <h5 v-html="slide.title"></h5>
          <div v-html="slide.subtitle"></div>
          
          <Link :link="slide.link[0]" v-if="slide.link.length > 0" :pageData="pageData"></Link>
        </article>
      </transition-group>

      <button class="CarouselElement__button CarouselElement__button--next"
        :class="{ 'CarouselElement__button--inactive': onLastSlide }" @click="slideNext"></button>
    </div>
  </section>
</template>
<script>
import Link from '../util/Link.vue'; 
import LinkWrapper from '../util/LinkWrapper.vue'; 

export default {
  props: ["properties", "pageData"],
  components: {
    Link,
    LinkWrapper
  },
  data() {
    return {
      carousel: [],
      activeSlide: 0,
      direction: "next",
      animations: {
        prev: {
          name: "fadeOutRight",
        },
        next: {
          name: "fadeOutLeft",
        },
      },
    };
  },
  created() {
    this.prepareCarousel();
  },
  methods: {
    prepareCarousel() {
      this.carousel = this.properties.carouselElement.map((slide, i) => {
        slide.id = `Slide__${i}`;
        return slide;
      });
    },
    slidePrev() {
      if (!this.onFirstSlide) {
        this.direction = "prev";
        this.activeSlide--;
      }
    },
    slideNext() {
      if (!this.onLastSlide) {
        this.direction = "next";
        this.activeSlide += 1;
      }
    },
    getRouteFromID(id) {
      return app.manifest.getRouteFromID(id);
    },
    getMediaPath(src) {
      return app.manifest.getMediaPath(src)
    }
  },
  computed: {
    onFirstSlide() {
      return this.activeSlide === 0;
    },
    onLastSlide() {
      return this.activeSlide + 1 === this.carousel.length;
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/sass/_responsiveness.scss";

.CarouselElement {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: var(--light-grey);
  padding: 110px 0 80px 0;
  text-align: left;

  &>div {
    position: relative;
    width: 100%;
    max-width: var(--content-max-width);
    padding: var(--content-padding);
    height: 560px;

    article {
      position: absolute;
      display: flex;
      flex-direction: column;
      max-width: var(--content-max-width-nopadding);

      &>* {
        padding: 0;
      }

      .CarouselElement__imgwrapper {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        max-height: 400px;
        overflow: hidden;
        margin-bottom: 20px;

        img {
          position: relative;
          left: 50%;
          transform: translateX(-50%);
          width: 100%;
        }
      }

      h5 {
        margin-bottom: 20px;
      }

      &>div {
        min-height: 80px;
        margin-bottom: 20px;

        &>p {
          padding: 0;
        }
      }

      a.hyperLink {
        padding: 0;
        color: var(--secondary-color);

        svg {
          fill: var(--secondary-color);
        }
      }
    }

    .CarouselElement__button {
      position: absolute;
      top: 200px;
      transform: translateY(-50%);
      width: 60px;
      height: 60px;
      cursor: pointer;
      border-radius: 1000px;
      background-image: url(@/assets/img/ui/btn-next.svg);
      background-size: 100%;
      background-position: center;
      background-repeat: no-repeat;
      transform-origin: 50% 0;
      transition: var(--tk-easeinout) 0.1s transform;

      &.CarouselElement__button--prev {
        right: calc(100% + 80px);
        rotate: 180deg;
      }

      &.CarouselElement__button--next {
        left: calc(100% + 80px);
      }

      &.CarouselElement__button--inactive {
        background-image: url(@/assets/img/ui/btn-next-outline.svg);
        pointer-events: none;
      }

      &:hover {
        transform: scale(1.05) translateY(-50%);
      }
    }
  }

  @include tablet-down {
    padding: 130px 0 50px 0;

    &>div {
      article {
        h5 {
          margin-bottom: 20px;
        }
      }

      .CarouselElement__button {
        top: -30px;
        width: 40px;
        height: 40px;

        &.CarouselElement__button--prev {
          right: 85px;
        }

        &.CarouselElement__button--next {
          left: auto;
          right: 35px;
        }
      }
    }
  }
}
</style>